// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"slider_navWrapper__ffLCa","sliderButton":"slider_sliderButton__s_fi5"};